mutation updateCompanySlogan($input: UpdateCompanySloganInput!) {
  updateCompanySlogan(input: $input)
}
